export default "__VITE_ASSET__AFAmRwh2__"